export type FieldType = 'text' | 'email' | 'phone' | 'select' | 'textarea' | 'number' | 'date' | 'checkbox';
export type FormStatus = 'Active' | 'Inactive' | 'Draft';
export type ResponseStatus = 'New' | 'Reviewed' | 'Converted' | 'Dismissed';

export interface FormField {
  id: string;
  type: FieldType;
  label: string;
  placeholder?: string;
  required: boolean;
  options?: string[];
}

export interface CaptureForm {
  id: string;
  name: string;
  description: string;
  status: FormStatus;
  icon: string;
  color: string;
  fields: FormField[];
  submissions: number;
  converted: number;
  views: number;
  createdAt: string;
  updatedAt: string;
  embedDomain?: string;
  category: string;
}

export interface FormResponse {
  id: string;
  formId: string;
  formName: string;
  formColor: string;
  submittedAt: string;
  status: ResponseStatus;
  data: Record<string, string>;
  ipCountry: string;
  device: 'Mobile' | 'Desktop' | 'Tablet';
  source: string;
  leadId?: string;
}

export interface ConversionStat {
  month: string;
  views: number;
  submissions: number;
  converted: number;
}

export const captureForms: CaptureForm[] = [];

export const formResponses: FormResponse[] = [];

export const conversionStats: ConversionStat[] = [];

export const lcKPIs = {
  totalForms: 0,
  activeForms: 0,
  totalSubmissions: 0,
  submissionsThisMonth: 0,
  totalConverted: 0,
  conversionRate: 0,
  totalViews: 0,
  newLeadsThisMonth: 0,
};

export const sourceBreakdown: { source: string; count: number; color: string }[] = [];
